import { useContext, useEffect, useState } from "react";
import { WebSocketContext } from "../providers/Websocket";

type MessageState = { data: string; timestamp: number } | null;

export default function useWebSocketMessage() {
  const { socket } = useContext(WebSocketContext);
  const [message, setMessage] = useState<MessageState>(null);

  useEffect(() => {
    let isMounted = true;
    const handleMessage = (event: MessageEvent) => {
      if (isMounted) {
        setMessage({ data: event.data, timestamp: Date.now() });
      }
    };
    if (socket) {
      socket.addEventListener("message", handleMessage);
    }
    return () => {
      isMounted = false;
      if (socket) {
        socket.removeEventListener("message", handleMessage);
      }
    };
  }, [socket]);

  return message;
}
